
































import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class AppButtonCloseEditFailure extends Vue {
  getRouteEditFailureTracking() {
    return this.$router.push({
      name: "edit-failure-tracking",
      params: { id: this.$route.params.id },
    });
  }

  onCloseFailure() {
    this.$store.commit("CLOSE_FAILURE");
  }

  get status() {
    return this.$route.query.status;
  }
}
